module.exports = __webpack_public_path__ + "img/image4.a8841dd8.png";